// ========= IMPORTS ==========

// Global app styles
import './App.css';


import PanelistNumpad from './components/PanelistEntry';
import SurveyEntry from './components/SurveyEntry';
import VasConnectStatus from './components/VasConnectStatus';

// React Router: provides declarative routing in React
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Remaining individual screen components (each one represents a route in the app)
import WelcomeScreen from './components/WelcomeScreen';
import GeneralInstructions from './components/GeneralInstructions';
import IPGI from './components/ImplicitPracticeInstructions';
import IPG from './components/ImplicitPracticeGame';
import IMGI1 from './components/ImplicitMatchingInstructionsOne';
import IMGI2 from './components/ImplicitMatchingInstructionsTwo';
import IMG2 from './components/ImplicitMatchingGameTwo';
import IMG1 from './components/ImplicitMatchingGameOne';
import IATDef from './components/IATDefinitions';
import IATDir from './components/IATDirections';
import PlayingAroma from './components/PlayingAroma';
// import IATTest from './components/IATTest';
// import IATBreak from './components/IATIntermission';
import ExplicitQuestions from './components/Explicitquestions';
import Demographics from './components/Demographics';
import Thankyou from './components/ThankYou';
// import Test from './components/test';

// Authentication and session components
import LoginScreen from './components/login';
import Logoutcreen from './components/logout';
import PrivateRoute from './components/PrivateRoute';
import { CommonProvider } from './context/CommonContext';
import { IATTestThankYou } from './components/IATTestThankYou';
import IATTestv2 from './components/IATTestv2';
import LanguageProvider from './context/LanguageProvider';
import IATTestv2a from './components/IATTestv2a';
import IATTestv2b from './components/IATTestv2b';

// ========= COMPONENT DEFINITION ==========

function App() {

  // Dev/debug only: logs to console when App component renders
  console.log("------------------app rendered----------------------");

  return (
    <div className="App">
      {/* Sets up browser-based routing for navigation */}
      <Router>

        {/* GLOBAL CONTEXT PROVIDERS: 
            Wrap the entire app in providers so every child route has access */}
        <CommonProvider>
          <LanguageProvider>

            {/* Persistent status indicator — always visible regardless of route */}
            <VasConnectStatus />

            {/* Route definitions: all paths map to components */}
            <Routes>
              {/* Public routes (no authentication) */}
              <Route path='/login' element={<LoginScreen />} />
              <Route path='/logout' element={<Logoutcreen />} />

              {/* Protected routes (require auth) are wrapped in <PrivateRoute />, 
                  which will handle access control and redirect if needed */}

              {/* Entry screen for survey selection */}
              <Route path="/" element={<PrivateRoute element={<SurveyEntry />} />} />

              {/* Panelist login keypad */}
              <Route path="/Panelist" element={<PrivateRoute element={<PanelistNumpad />} />} />

              {/* Sequence of screens for participant experience */}
              <Route path="/Welcome" element={<PrivateRoute element={<WelcomeScreen />} />} />
              <Route path="/GeneralInstructions" element={<PrivateRoute element={<GeneralInstructions />} />} />
              <Route path="/IPGI" element={<PrivateRoute element={<IPGI />} />} />
              <Route path="/IPG" element={<PrivateRoute element={<IPG />} />} />
              <Route path="/IMGI1" element={<PrivateRoute element={<IMGI1 />} />} />
              <Route path="/IMG1" element={<PrivateRoute element={<IMG1 />} />} />
              <Route path="/IMGI2" element={<PrivateRoute element={<IMGI2 />} />} />
              <Route path="/IMG2" element={<PrivateRoute element={<IMG2 />} />} />
              <Route path="/IATDef" element={<PrivateRoute element={<IATDef />} />} />
              <Route path="/IATDir" element={<PrivateRoute element={<IATDir />} />} />
              <Route path="/playingAroma" element={<PrivateRoute element={<PlayingAroma />} />} />
              {/* <Route path="/IATTest" element={<PrivateRoute element={<IATTest />} />} /> */}
              <Route path="/IATTestv2" element={<PrivateRoute element={<IATTestv2 />} />} />
              <Route path="/IATTestv2a" element={<PrivateRoute element={<IATTestv2a />} />} />
              <Route path="/IATTestv2b" element={<PrivateRoute element={<IATTestv2b />} />} />
              <Route path="/IATTestThankYou" element={<PrivateRoute element={<IATTestThankYou />} />} />
              {/* <Route path="/IATBreak" element={<PrivateRoute element={<IATBreak />} />} /> */}
              <Route path="/ExplicitQuestions" element={<PrivateRoute element={<ExplicitQuestions />} />} />
              <Route path="/Demographics" element={<PrivateRoute element={<Demographics />} />} />

              {/* Final thank-you page at the end of the flow */}
              <Route path="/thankyou" element={<PrivateRoute element={<Thankyou />} />} />

              {/* Development / experimental routes */}
              {/* <Route path="/test" element={<PrivateRoute element={<Test />} />} /> */}
              {/* <Route path="/testgame" element={<PrivateRoute element={<ReactionTimeGame/>} />} /> */}
            </Routes>

            {/* </LoopProvider> */}
          </LanguageProvider>
        </CommonProvider>
      </Router>
    </div>
  );
}

export default App;
